<!--
This components makes heavy use of  VeeValidate (https://baianat.github.io/vee-validate/) for form validation
-->

<template>
  <div>
    <b-field grouped  class="columns">
      <b-field label="First Name"  expanded class="column" ::type="calculateFieldType('first name')">
        <b-input v-model="userInfo.accountFirstName"
                 name="first name"
                 expanded
                 v-validate="{required: true}"
                 required
                 autofocus></b-input>
      </b-field>
      <b-field label="Last Name" expanded class="column" :type="calculateFieldType('last name')">
        <b-input v-model="userInfo.accountLastName"
                 name="last name"
                 expanded
                 v-validate="{required: true}"
                 required></b-input>
      </b-field>
    </b-field>

    <b-field grouped class="columns">
      <b-field label="Email Address" expanded class="column" :type="calculateFieldType('email')">
        <b-input v-model="userInfo.accountEmailAddress"
                 :disabled="isPrePopulated"
                 name="email"
                 expanded
                 v-validate="{required: true, email: true}"
                 type="email"
                 required></b-input>
      </b-field>

      <b-field label="Mobile Phone Number" expanded class="column" :type="calculateFieldType('phone number')">
        <phone-number-input v-model="userInfo.accountPhones[0].accountPhoneDigits"
                            name="phone number"
                            expanded
                            v-validate="{required: true, regex: /\d+/}"
                            type="tel"
                            required
        />
      </b-field>
    </b-field>

    <b-field grouped class="columns">
      <b-field label="Password" expanded class="column" >
        <b-field :type="calculateFieldType('password')">
          <!--
          <p class="control">
            <b-tooltip
              label="Must contain at least one number, one capital letter and be at least 8 characters in length."
              type="is-dark"
              animated
              multilined>
            <a class="button">
              <font-awesome-icon icon="info-circle" size="lg" />
            </a>
            </b-tooltip>
          </p>
          -->

        <b-input v-model.lazy="userInfo.accountPassword"
                 name="password"
                 :disabled="isPrePopulated"
                 ref="passwordInput"
                 expanded
                 type="password"
                 v-validate="{required: true, regex: validPasswordFormat}"
                 password-reveal
                 required></b-input>
          <template v-if="!isPrePopulated">
          Must contain at least one number, one capital letter and be at least 8 characters in length.
          </template>

        </b-field>

      </b-field>
      <b-field label="Confirm password" class="column" expanded :type="{ 'is-danger': !doesPasswordsMatch }">
        <b-input v-model="passwordConfirmation"
                 name="password_confirmation"
                 :disabled="isPrePopulated"
                 expanded
                 type="password"
                 v-validate="{required: true, regex: validPasswordFormat}"
                 password-reveal
                 required></b-input>
      </b-field>
    </b-field>

    <!--
    <b-field grouped class="columns" >
      <b-field label="Security Question" expanded class="column" :type="calculateFieldType('first security question')">
        <b-select v-model="userInfo.accountSecurityQuestion1"
                  name="first security question"
                  v-validate="{required: true}"
                  required
                  expanded>
          <option v-for="question in availableSecurityQuestions1" :value="question" :key="question"> {{question}}</option>
        </b-select>
      </b-field>
      <b-field label="Answer" expanded class="column" :type="calculateFieldType('first security answer')">
        <b-input v-model="userInfo.accountSecurityQuestionAnswer1"
                 name="first security answer"
                 v-validate="{required: true}"
                 required
                 expanded></b-input>
      </b-field>
    </b-field>

    <b-field grouped class="columns">
      <b-field label="Security Question" expanded class="column" :type="calculateFieldType('second security question')">
        <b-select v-model="userInfo.accountSecurityQuestion2"
                  name="second security question"
                  v-validate="{required: true}"
                  required
                  expanded>
          <option v-for="question in availableSecurityQuestions2" :value="question" :key="question"> {{question}}</option>
        </b-select>
      </b-field>
      <b-field label="Answer" expanded class="column" :type="calculateFieldType('second security answer')">
        <b-input v-model="userInfo.accountSecurityQuestionAnswer2"
                 name="second security answer"
                 v-validate="{required: true}"
                 required
                 expanded></b-input>
      </b-field>
    </b-field>

    <b-field grouped class="columns">
      <b-field label="Security Question" expanded class="column" :type="calculateFieldType('third security question')">
        <b-select v-model="userInfo.accountSecurityQuestion3"
                  name="third security question"
                  v-validate="{required: true}"
                  required
                  expanded>
          <option v-for="question in availableSecurityQuestions3" :value="question" :key="question"> {{question}}</option>
        </b-select>
      </b-field>
      <b-field label="Answer" expanded class="column" :type="calculateFieldType('third security answer')">
        <b-input v-model="userInfo.accountSecurityQuestionAnswer3"
                 name="third security answer"
                 v-validate="{required: true}"
                 required
                 expanded></b-input>
      </b-field>
    </b-field>
    -->

    <b-field v-if="!isPrePopulated">
      <b-checkbox v-model="userInfo.accountTrucklTAndCAcceptedFlag"
                  :disabled="isPrePopulated"
                  v-validate="{required: true}"
                  name="terms and conditions">
        I agree to the <a href="" @click.stop.prevent="toggleTandC">Truckl Terms and Conditions</a>
      </b-checkbox>
    </b-field>

    <terms-and-conditions :show.sync="showTandC"></terms-and-conditions>

  </div>
</template>

<script>
import TermsAndConditions from '@/components/ModalWebTermsAndConditions'
import securityQuestionsList from '@/lookup-data/security-questions'
import { isEmpty, merge, difference as diff } from 'lodash-es'
import PhoneNumberInput from '@/components/PhoneNumberInput'
import { validPasswordFormat } from '@/helpers/passwordValidation.js'

export default {
  name: 'FormAccountInformation',

  model: {
    prop: 'existingUserInfo',
    event: 'input'
  },

  props: {
    existingUserInfo: {
      type: Object,
      default: () => {}
    },

    populatedEmail: {
      type: String,
      default: () => ''
    }
  },

  created() {
    if (this.isPrePopulated) {
      this.userInfo = merge({}, this.userInfo, this.existingUserInfo)
    }

    if (this.populatedEmail) {
      this.userInfo.accountEmailAddress = this.populatedEmail
    }
  },

  mounted() {
    if (this.isPrePopulated) {
      this.userInfo = merge({}, this.userInfo, this.existingUserInfo)
    }

    if (this.populatedEmail) {
      this.userInfo.accountEmailAddress = this.populatedEmail
    }
  },

  data() {
    return {
      validPasswordFormat,
      userInfo: {
        accountEmailAddress: '',
        accountFirstName: '',
        accountLastName: '',
        accountPassword: '',
        accountTrucklTAndCAcceptedFlag: false,
        accountSecurityQuestion1: '',
        accountSecurityQuestion2: '',
        accountSecurityQuestion3: '',
        accountSecurityQuestionAnswer1: '',
        accountSecurityQuestionAnswer2: '',
        accountSecurityQuestionAnswer3: '',
        accountPhones: [
          {
            accountPhoneDigits: '',
            accountPhonePrimaryFlag: true,
            accountPhoneType: 'cell'
          }
        ]
      },
      passwordConfirmation: '',
      showTandC: false
    }
  },

  components: {
    TermsAndConditions,
    PhoneNumberInput
  },

  computed: {
    isPrePopulated() {
      return (
        (!isEmpty(this.existingUserInfo) && !isEmpty(this.existingUserInfo.accountKey)) || !isEmpty(this.populatedEmail)
      )
    },

    /**
     * List of available security questions (specific to question 1)
     * As questions are selected... make sure we only show them to the user once.
     */
    availableSecurityQuestions1() {
      const selectedQuestions = [this.userInfo.accountSecurityQuestion2, this.userInfo.accountSecurityQuestion3]
      return diff(securityQuestionsList, selectedQuestions)
    },

    /**
     * List of available security questions (specific to question 2)
     * As questions are selected... make sure we only show them to the user once.
     */
    availableSecurityQuestions2() {
      const selectedQuestions = [this.userInfo.accountSecurityQuestion1, this.userInfo.accountSecurityQuestion3]
      return diff(securityQuestionsList, selectedQuestions)
    },

    /**
     * List of available security questions (specific to question 3)
     * As questions are selected... make sure we only show them to the user once.
     */
    availableSecurityQuestions3() {
      const selectedQuestions = [this.userInfo.accountSecurityQuestion1, this.userInfo.accountSecurityQuestion2]
      return diff(securityQuestionsList, selectedQuestions)
    },

    /**
     * Flag indicating if the confirmation password and password match
     * @returns {boolean}
     */
    doesPasswordsMatch() {
      // there is a bug in the veevalidate plugin... so this custom function is needed
      let match = true
      if (this.passwordConfirmation.length > 1) {
        match = this.userInfo.accountPassword === this.passwordConfirmation
      }

      return match
    }
  },

  methods: {
    /**
     * Toggles visibility of the "Terms & Conditions" modal
     */
    toggleTandC() {
      this.showTandC = !this.showTandC
    },

    async validate() {
      return this.$validator.validate()
    },

    /**
     *
     * @param {String} fieldName The name of the field in question (this is the name given to vee-validate)
     * @returns {string} CSS class to be applied
     */
    calculateFieldType(fieldName) {
      // TODO: this might make a good candidate for a mix-in
      return this.validationErrors.has(fieldName) ? 'is-danger' : ''
    }
  },

  watch: {
    // TODO: this might make a good candidate for a mix-in
    validationFields: {
      deep: true,
      async handler() {
        const isValid = this.$validator.errors.items.length === 0
        // because I could not figure out how to configure the "invalidateFalse" settings.... I'm manually checking that
        // the T & C's check-box is true (but the component it still part of the veevalidate scope)
        const isComplete = isValid && this.userInfo.accountTrucklTAndCAcceptedFlag && this.doesPasswordsMatch

        this.$emit('input', this.userInfo)
        this.$emit('isComplete', isComplete)
      }
    }
  }
}
</script>
